import { Component, OnInit } from '@angular/core';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { PspService } from 'src/app/admihair/service/psp.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { Psp } from 'src/app/admihair/api/dto/psp';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { PspConfiguracaoEmpresa } from 'src/app/admihair/api/dto/psp-configuracao-empresa';
import { PspConfiguracaoEmpresaService } from 'src/app/admihair/service/psp-configuracao.service';

@Component({
  selector: 'app-configuracao-pix-detalhar',
  templateUrl: './configuracao-pix-detalhar.component.html',
  styleUrls: ['./configuracao-pix-detalhar.component.scss']
})
export class ConfiguracaoPixDetalharComponent extends AdmihairBaseComponent implements OnInit {

  loading: boolean = false;
  psp?: PspConfiguracaoEmpresa;

  constructor(
    private pspConfiguracaoEmpresaService: PspConfiguracaoEmpresaService,
    erroService: ErroService, storageService: UtilStorageService,
    router?: Router,
    activatedRoute?: ActivatedRoute) {
    super(erroService, storageService, router, activatedRoute)
  }

  ngOnInit(): void {
    this.loading = true;
    this.carregarIdUrl();
    this.permissaoDetalhar = this.verificarPermissao('PERM_CONFIGURACAO_PIX');
    this.carregar();
  }

  carregar() {
    this.pspConfiguracaoEmpresaService.buscarPorId(this.idParametroUrl).subscribe({
      next: (data: PspConfiguracaoEmpresa) => {
        this.psp = data;
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.exibirMensagemErro(err);
      }
    })
  }

}
